document.addEventListener("DOMContentLoaded", function () {
  // Add preconnect hints only once
  if (!document.querySelector('link[href="https://www.youtube.com"]')) {
    const preconnectYoutube = document.createElement("link");
    preconnectYoutube.rel = "preconnect";
    preconnectYoutube.href = "https://www.youtube.com";
    document.head.appendChild(preconnectYoutube);

    const preconnectYoutubeImg = document.createElement("link");
    preconnectYoutubeImg.rel = "preconnect";
    preconnectYoutubeImg.href = "https://i.ytimg.com";
    document.head.appendChild(preconnectYoutubeImg);
  }

  // Initialize all video players with class pattern
  function initVideoPlayers(selector) {
    document.querySelectorAll(selector).forEach(function (button) {
      // Skip if already initialized
      if (button.hasAttribute("data-initialized")) return;
      button.setAttribute("data-initialized", "true");

      button.addEventListener("click", function (e) {
        e.preventDefault();

        const videoItem = button.closest("[data-youtube-id]");
        if (!videoItem) return;

        const youtubeId = videoItem.getAttribute("data-youtube-id");
        if (!youtubeId || youtubeId.trim() === "") return;

        // Create YouTube iframe
        const iframe = document.createElement("iframe");
        iframe.src = `https://www.youtube.com/embed/${youtubeId}?autoplay=1&rel=0`;
        iframe.frameBorder = "0";
        iframe.allow =
          "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";
        iframe.allowFullscreen = true;
        iframe.style.position = "absolute";
        iframe.style.top = "0";
        iframe.style.left = "0";
        iframe.style.width = "100%";
        iframe.style.height = "100%";

        // Get video title from thumbnail alt
        const thumbnail = videoItem.querySelector("img");
        if (thumbnail && thumbnail.alt) {
          iframe.title = thumbnail.alt;
        }

        // Find preview container (parent of the button)
        const previewContainer = button.parentElement;
        if (previewContainer) {
          previewContainer.innerHTML = "";
          previewContainer.appendChild(iframe);
        }
      });
    });
  }

  // Initialize for different sections
  initVideoPlayers(".siccas-video-overview__video-play");
  initVideoPlayers(".siccas-video-hero__video-play");
  initVideoPlayers(".siccas-video-gallery__video-play");

  // Initialize for different sections
  initVideoPlayers(".siccas-video-overview__video-play");
  initVideoPlayers(".siccas-video-hero__video-play");
  initVideoPlayers(".siccas-video-gallery__video-play");
  initVideoPlayers(".product-media__video-play"); // Добавить эту строку
});
